import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { BusinessCard } from "@/components/BusinessCard";

const API_URL = '';

export default function SavedPage() {
  const { favorites } = useFavorites();
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSavedBusinesses = async () => {
      if (favorites.length === 0) {
        setBusinesses([]);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/public/businesses`);
        if (response.ok) {
          const allBusinesses = await response.json();
          const savedBusinesses = allBusinesses.filter(biz => 
            favorites.includes(biz.business_id)
          );
          setBusinesses(savedBusinesses);
        }
      } catch (error) {
        console.error('Failed to fetch businesses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedBusinesses();
  }, [favorites]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-6 h-6 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F2F2F7] pb-28" data-testid="saved-page">
      {/* Compact Header - 56px height */}
      <header className="sticky top-0 z-40 glass-header h-14 px-5">
        <div className="max-w-lg mx-auto h-full flex items-center">
          <div>
            <h1 className="text-base font-semibold text-slate-900">
              Saved
            </h1>
            <p className="text-xs text-slate-500">
              {favorites.length} {favorites.length === 1 ? 'place' : 'places'} saved
            </p>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="px-5 pt-6">
        <div className="max-w-lg mx-auto">
          {businesses.length === 0 ? (
            <div className="text-center py-24">
              <div className="w-20 h-20 rounded-3xl layer-card flex items-center justify-center mx-auto mb-5">
                <Heart className="w-9 h-9 text-slate-300" />
              </div>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                No saved places yet
              </h2>
              <p className="text-sm text-slate-500 max-w-[240px] mx-auto">
                Tap the heart icon on any place to save it for later
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              {businesses.map((business) => (
                <BusinessCard 
                  key={business.business_id} 
                  business={business}
                  showCategory={true}
                />
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
